<template>
  <div class="video_wrap">
    <IframeVideo :url="videoURL" />

    <img v-if="demoImg" :src="demoImg" alt="">
    <div class="bottom">
      <div class="contrl">
        <div class="left">
          <div class="circular circular1">
            <div class="circular circular2">
              <!-- 圆点 -->
              <div class="circular circular3"></div>
              <!-- 四个角 -->
              <a href="#" class="horn horn-top" @click="handleCtrlClick(0)">
                <i class="iconfont icon-xiangxia" />
              </a>
              <a href="#" class="horn horn-right" @click="handleCtrlClick(3)">
                <i class="iconfont icon-xiangxia" />
              </a>
              <a href="#" class="horn horn-bottom" @click="handleCtrlClick(1)">
                <i class="iconfont icon-xiangxia" />
              </a>
              <a href="#" class="horn horn-left" @click="handleCtrlClick(2)">
                <i class="iconfont icon-xiangxia" />
              </a>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="r_top">
            <div class="box" @click="handleCapture">
              <div class="r_block">
                <img src="./../../../assets/images/shibie.jpg" alt="" />
                <!-- <i
                  class="saoma iconfont icon-icon--"
                  style="font-size: 32px"
                ></i> -->
                <!-- <i class="miaozhun iconfont icon-xialingyingicon-16"></i> -->
              </div>
              <div class="label">识别</div>
            </div>
            <div class="box" @click="handleCtrlClick(10)">
              <div class="r_block">
                <img src="./../../../assets/images/miaozhun.jpg" alt="" />
                <!-- <i
                  class="saoma iconfont icon-icon--"
                  style="font-size: 32px"
                ></i>
                <i class="miaozhun iconfont icon-xialingyingicon-16"></i> -->
              </div>
              <div class="label">对焦</div>
            </div>
          </div>
          <div class="r_bottom">
            <div class="box" @click="handleCtrlClick(8)">
              <div class="r_block">
                <i class="iconfont icon-jia" style="font-size: 22px"></i>
              </div>
              <div class="label">放大</div>
            </div>
            <div class="box" @click="handleCtrlClick(9)">
              <div class="r_block">
                <i class="iconfont icon-jian" style="font-size: 22px"></i>
              </div>
              <div class="label">放小</div>
            </div>
          </div>
        </div>
      </div>
      <div class="calendar">
        <div class="left">
          <div :class="['date-item', currentDateIndex === index && 'active']" v-for="(item, index) in dates" :key="item.date" @click="handleClickDate(item, index)">
            <div class="week">{{ item.week }}</div>
            <div class="num">{{ item.num }}</div>
          </div>
        </div>
        <div class="right" @click="show = true">
          <i class="iconfont icon-rili" style="font-size: 38px"> </i>
          <span> {{ today.num }}</span>
        </div>
      </div>
      <div class="img-group">
        <div v-for="(item, index) in list" :key="index + 1000">
          <!-- <div class="date">{{ item.date }}</div> -->
          <div class="time">
            {{ item.date }} {{ item.week && `周${item.week}` }}
          </div>
          <div class="pic">
            <div v-if="pic" class="pic_item" v-for="(pic, _index) in item.picList" :key="_index">
              <!--  -->
              <ImageProxy :url="pic.url" :index="index" :_index="_index" :click="handleClickImg" />
              <div class="time">{{ pic.cdate }}</div>
            </div>
            <div v-else class="pic_item"></div>
          </div>
        </div>
      </div>
    </div>

    <van-calendar v-model="show" @confirm="onConfirm" :max-date="maxDate" :min-date="minDate" />
  </div>
</template>

<script>
import IframeVideo from "./../components/iframe.vue";
import moment from "moment";

export default {
  components: {
    IframeVideo,
  },
  data () {
    return {
      dates: [],
      currentDateIndex: null,
      today: {},
      show: false,
      minDate: new Date("1970/1/1"),
      maxDate: new Date(),
      videoURL: "",
      channelNo: "",
      ysNo: "",
      isFirst: true,
      page: 1,
      pageSize: 20,
      oldList: [],
      totalPages: 1,
      list: [],
      finished: true,
      demoImg: ""
    };
  },

  async mounted () {
    let { url, channelNo, ysNo } = this.$route.query;
    this.videoURL = url;
    this.channelNo = channelNo;
    this.ysNo = ysNo;
    // 计算7天时间
    await this.sevenDays(new Date());
    this.currentDateIndex = this.dates.length - 1;
    this.today = this.formatCalendarDay(new Date(), 0);
    // this.calculateCalendar();
    this.getPicture();
  },

  methods: {
    // calculateCalendar() {},

    // 日历 确认
    onConfirm (date) {
      this.sevenDays(date);
      this.currentDateIndex = this.dates.length - 1;
      this.show = false;
      this.getPicture()
    },

    // 切换日期
    handleClickDate (date, index) {
      this.currentDateIndex = index;
      // 请求视频和图片
      this.getPicture()
    },

    // 视频控制
    async handleCtrlClick (index) {
      if (typeof index !== "number") return;
      await this.$api
        .ctrlCamera({
          ysNo: this.ysNo,
          channelNo: Number(this.channelNo),
          direction: String(index),
        })
        .then((res) => {
          if (res.errcode === 0) {
          } else {
            this.$toast.fail(res.errmsg);
          }
        });
    },

    // 获取摄像头下的图片列表
    async getPicture () {
      await this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0,
      });

      try {
        this.isFirst = false;
        const { page, pageSize } = this;
        const res = await this.$api.getCameraPicture({
          gatewayNo: localStorage.getItem("no"),
          // gatewayNo: "1000000333",
          page,
          pageSize: 5000,
          leDate: this.dates[this.currentDateIndex].date
        });
        this.$toast.clear();

        const list = res.list;

        if (list && list.length) {
          let timeGroup = new Set();
          const newList = [...list];

          // 合在一起后再进行日期分组
          newList.map((item) => {
            if (item.date == null) {
              timeGroup.add(item.cdate.split(" ")[0]);
            } else {
              timeGroup.add(item.date);
            }
          });
          timeGroup = Array.from(timeGroup);
          const newTimeGroup = [];
          timeGroup.map((item) => {
            newTimeGroup.push({
              date: item,
              picList: [],
              week: item ? this.getWeek(item) : "",
            });
          });

          newTimeGroup.map((item) => {
            newList.map((_item) => {
              let date = "";
              if (_item.date == null) {
                date = _item.cdate.split(" ")[0];
              } else {
                date = _item.date;
              }

              if (item.date === date) {
                _item.cdate = _item.cdate ? _item.cdate.split(" ")[1] : "";

                item.picList.push({
                  ..._item,
                });
              }
            });
          });

          newTimeGroup.map((item) => {
            if (item.picList && item.picList.length) {
              const count = 3;
              const m = item.picList.length % count;
              if (m) {
                const l = count - m;
                let arr = {};
                arr.length = l;
                arr = Array.from(arr);
                arr.map(() => {
                  item.picList.push(null);
                });
              }
            }
          });

          this.list = [...newTimeGroup];

          console.log("list:", this.list, this.finished);

          this.totalPages = res.pages;
          this.page++;
        } else {
          this.list = [];
          this.page = 1
        }
      } catch (err) {
        this.$toast.clear();
        console.error(err);
      }
    },

    /**
     * @description 图片点击
     * @param {number} index list中的下标
     * @param {number} _index list中下标对象中的picList中的第几个
     */
    handleClickImg (index, _index) {
      const images = [];
      this.list[index].picList.map((item) => {
        item && images.push(item);
      });

      const { url, cdate, fileId } = images[_index];

      this.$router.push({
        path: "/ai",
        query: {
          imgUrl: url,
          time: cdate,
          fileId,
        },
      });
    },

    // 截图
    async handleCapture () {
      this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0,
      });

      try {
        const res = await this.$api.capture({
          gatewayNo: localStorage.getItem("no"),
          channelNo: this.channelNo,
          quality: 0,
        });

        if (res && res.errcode === 0 && res.picUrl) {
          this.$toast.clear();
          const { picUrl, fileId, } = res
          // this.demoImg = res.picUrl
          this.$router.push({
            path: "/ai",
            query: {
              imgUrl: picUrl,
              time: moment(new Date().getTime()).startOf("s").format("YYYY-MM-DD HH:mm:ss"),
              fileId,
            },
          });
          this.getPicture();
        } else {
          this.$toast.fail((res && res.errmsg) || this.$t("common.service_error"));
          this.demoImg = "";
        }
      } catch (err) {
        this.$toast.fail(this.$t("common.service_error"));
      }
    },

    sevenDays (date) {
      const nowDate = moment(date).startOf("day").format("YYYY-MM-DD"); // 当前时间点
      const dates = [];
      for (let i = 0; i < 6; i++) {
        dates.push(this.formatCalendarDay(nowDate, i + 1));
      }
      dates.reverse();
      dates.push(this.formatCalendarDay(nowDate, 0));

      console.log("dates:", dates);
      this.dates = dates;
    },

    // 参数时间戳
    getWeek (date) {
      let week = moment(date).day();
      switch (week) {
        case 1:
          return "一";
        case 2:
          return "二";
        case 3:
          return "三";
        case 4:
          return "四";
        case 5:
          return "五";
        case 6:
          return "六";
        case 0:
          return "日";
      }
    },

    formatCalendarDay (date, i) {
      const d = moment(date).subtract(i, "days").format("YYYY-MM-DD");
      return {
        date: d,
        week: this.getWeek(new Date(d.replaceAll("-", "/")).getTime()),
        num: d.split("-")[2],
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.video_wrap {
  .video {
    width: 100%;
    height: 220px;
    background: #999;
  }

  .body {
    padding: 12px 10px;
  }

  .contrl {
    display: flex;
    margin-bottom: 22px;
    padding: 12px;
    width: 100%;
    box-sizing: border-box;

    .left {
      position: relative;
      flex: 1;
      width: 50%;

      .circular {
        border-radius: 50%;
      }

      .circular1 {
        position: relative;
        width: 183.54px;
        height: 183.54px;
        background: rgba(241, 246, 251, 1);
        box-shadow: 2px 2px 8px 0px rgba(37, 87, 210, 0.15);
        text-align: center;
      }

      .circular2 {
        position: absolute;
        left: 20px;
        top: 20px;
        width: 144px;
        height: 144px;
        background: linear-gradient(
            129.67deg,
            rgba(122, 127, 133, 0.4) 0%,
            rgba(255, 255, 255, 0.4) 100%
          ),
          linear-gradient(
            133.76deg,
            rgba(230, 231, 237, 1) 0%,
            rgba(247, 248, 250, 1) 100%
          );
        background-blend-mode: soft-light;
        box-shadow: inset 1px 1px 3px 0px rgba(235, 236, 240, 1),
          -2px -3px 8px 0px rgba(250, 250, 252, 1),
          1px 1px 5px 0px rgba(177, 181, 198, 1);
      }

      .circular3 {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 20.17px;
        height: 20.17px;
        background: rgba(37, 87, 210, 1);
      }

      .horn {
        position: absolute;

        i {
          color: rgba(206, 213, 220, 1);
          font-size: 22px;
        }
      }

      .horn-top {
        top: 0px;
        left: 60px;
        transform: rotateX(145deg);
      }

      .horn-right {
        top: 52px;
        right: 6px;
        transform: rotate(-90deg);
      }

      .horn-bottom {
        bottom: 0px;
        left: 63px;
      }

      .horn-left {
        top: 52px;
        left: 6px;
        transform: rotate(90deg);
      }
    }

    .right {
      flex: 1;
      padding: 16px 10px 0 30px;
      font-size: 14px;
      width: 50%;
      box-sizing: border-box;

      .box {
        text-align: center;

        .label {
          margin-top: 8px;
        }

        i {
          color: rgba(46, 95, 215, 1);
        }
      }

      .r_top,
      .r_bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // width: 50%;
        box-sizing: border-box;

        .r_block {
          position: relative;
          display: inline-block;
          width: 44.13px;
          height: 44.13px;
          line-height: 44.13px;
          text-align: center;
          background: linear-gradient(
              129.67deg,
              rgba(122, 127, 133, 0.4) 0%,
              rgba(255, 255, 255, 0.4) 100%
            ),
            linear-gradient(
              133.76deg,
              rgba(230, 231, 237, 1) 0%,
              rgba(247, 248, 250, 1) 100%
            );
          background-blend-mode: soft-light;
          box-shadow: inset 1px 1px 3px 0px rgba(235, 236, 240, 1),
            -2px -3px 4px 0px rgba(250, 250, 252, 1),
            1px 1px 2px 0px rgba(177, 181, 198, 1);
          border-radius: 10px;
        }

        .miaozhun {
          position: absolute;
          top: 1px;
          left: 2px;
          right: 0;
          bottom: 0;
          margin: 0;
          font-size: 20px;
        }

        img {
          width: 60%;
          height: 60%;
        }
      }

      .r_top {
        margin-bottom: 20px;
      }
    }
  }

  .calendar {
    display: flex;
    margin-bottom: 12px;
    font-size: 14px;

    .left {
      display: flex;
      margin-left: 10px;

      .date-item {
        width: 39.78px;
        height: 40.66px;
        margin-right: 6px;
        background: rgba(210, 234, 253, 1);
        border-radius: 10px;
        text-align: center;
      }

      .active {
        background: rgba(37, 87, 210, 1);
        color: #ffffff;

        &::after {
          display: table;
          content: " ";
          width: 6px;
          height: 6px;
          background: rgba(37, 87, 210, 1);
          border-radius: 50%;
          margin-left: 16px;
          margin-top: 5px;
        }
      }
    }

    .right {
      position: relative;
      font-size: 18px;
      span {
        position: absolute;
        top: 12px;
        left: 10px;
      }
    }
  }

  .img-group {
    padding: 0 10px 10px;

    .date {
      line-height: 40px;
      text-align: left;
    }

    .time {
      font-size: 12px;
      text-align: left;
    }

    .pic {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      width: 100%;

      .pic_item {
        width: 33%;
        // height: 100px;
        margin-bottom: 0.3rem;
        overflow: hidden;
        margin-right: 11px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
